import { useEffect } from 'react';

export const usePersistentScroll = (ref: React.RefObject<HTMLElement>, key: string) => {
  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    // Restore scrollLeft and scrollTop from sessionStorage
    const savedScrollKey = sessionStorage.getItem(`scroll-${key}`);
    if (savedScrollKey) {
      const { x, y } = JSON.parse(savedScrollKey);
      // Delay to ensure content is rendered
      setTimeout(() => {
        element.scrollLeft = x || 0;
        element.scrollTop = y || 0;
      }, 0);
    }

    // Save scroll position on scroll
    const handleScroll = () => {
      if (!element) return;
      sessionStorage.setItem(
        `scroll-${key}`,
        JSON.stringify({ x: element.scrollLeft, y: element.scrollTop }),
      );
    };

    element.addEventListener('scroll', handleScroll);
    return () => {
      element.removeEventListener('scroll', handleScroll);
    };
  }, [ref, key]);
};
